import { FC } from 'react';

import { ErrorBlock } from './ErrorBlock';
import { COUNTRIES } from 'helpers/conf';
import { useScrollBlock } from '@repo-level/core-front';

interface NotAllowedCountryProps {
  countryCode: string;
}

export const NotAllowedCountry: FC<NotAllowedCountryProps> = ({
  countryCode,
}) => {
  useScrollBlock();

  return (
    <ErrorBlock
      withBg
      withLogo
      richText={
        <>
          <p className="title">
            LuckyElf's journey is blocked from reaching {COUNTRIES[countryCode]}
            .
          </p>
          <p className="subtitle">
            It seems an Elf may have placed a barrier. If you're using a proxy
            or VPN, try turning it off and refreshing the page.
          </p>
        </>
      }
    />
  );
};
